import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../../config';
import { useNavigate } from 'react-router-dom';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const EMPTY_SCALE = { pre: '', intermedia: '', final: '' };
const CUESTIONARIO_TESIS = 3;

const parseScale = (scale) => ({
  pre: scale.pre === '' ? null : parseInt(scale.pre, 10),
  intermedia: scale.intermedia === '' ? null : parseInt(scale.intermedia, 10),
  final: scale.final === '' ? null : parseInt(scale.final, 10),
});

export const useCuestionarioTesisTorresForm = ({ idPaciente, idCuestionario }) => {
  const cookies = new Cookies();
  const token = cookies.get('TOKEN');
  const API_URL = `https://${config.BACKEND}:${config.PORT}/cuestionario`;
  const navigate = useNavigate();
  const isEdit = Boolean(idCuestionario);

  const [dolorCronico, setDolorCronico] = useState('');
  const [intensidadDolor, setIntensidadDolor] = useState('');
  const [minimental, setMinimental] = useState('');
  const [escalaDolor, setEscalaDolor] = useState({ ...EMPTY_SCALE });
  const [kinesiofobia, setKinesiofobia] = useState({ ...EMPTY_SCALE });
  const [catastrofismo, setCatastrofismo] = useState({ ...EMPTY_SCALE });
  const [gradacionDolorCronico, setGradacionDolorCronico] = useState({ ...EMPTY_SCALE });
  const [sf12, setSf12] = useState({ ...EMPTY_SCALE });
  const [openGood, setOpenGood] = useState(false);

  useEffect(() => {
    if (!isEdit) return;
    fetchCuestionarioById(idCuestionario, idPaciente)
      .then((data) => {
        const r = parseRespuestas(data?.respuestas);
        setDolorCronico(r.dolorCronico || '');
        setIntensidadDolor(r.intensidadDolor ?? '');
        setMinimental(r.minimental ?? '');
        setEscalaDolor(r.escalaDolor || { ...EMPTY_SCALE });
        setKinesiofobia(r.kinesiofobia || { ...EMPTY_SCALE });
        setCatastrofismo(r.catastrofismo || { ...EMPTY_SCALE });
        setGradacionDolorCronico(r.gradacionDolorCronico || { ...EMPTY_SCALE });
        setSf12(r.sf12 || { ...EMPTY_SCALE });
      })
      .catch((err) => console.error('Error fetching cuestionario Tesis Torres:', err));
  }, [isEdit, idCuestionario, idPaciente]);

  const handleScaleChange = (setter, field) => (e) =>
    setter((prev) => ({ ...prev, [field]: e.target.value }));

  const guardarDatos = async () => {
    const datos = {
      dolorCronico,
      intensidadDolor: intensidadDolor === '' ? null : parseInt(intensidadDolor, 10),
      minimental: minimental === '' ? null : parseInt(minimental, 10),
      escalaDolor: parseScale(escalaDolor),
      kinesiofobia: parseScale(kinesiofobia),
      catastrofismo: parseScale(catastrofismo),
      gradacionDolorCronico: parseScale(gradacionDolorCronico),
      sf12: parseScale(sf12),
    };
    const headers = { Authorization: `Bearer ${token}` };
    try {
      if (isEdit) {
        try {
          await axios.put(`${API_URL}/${idCuestionario}`, datos, { headers });
        } catch (err) {
          if (err.response?.status === 404) {
            await axios.post(`${API_URL}/${idCuestionario}`, datos, { headers });
          } else throw err;
        }
      } else {
        await axios.post(`${API_URL}/${idPaciente}/${CUESTIONARIO_TESIS}`, datos, { headers });
      }
      setOpenGood(true);
      setTimeout(() => navigate(isEdit ? -1 : `/paciente/${idPaciente}`), 1500);
    } catch (err) {
      console.error('Error guardando cuestionario Tesis Torres:', err);
    }
  };

  return {
    dolorCronico, setDolorCronico,
    intensidadDolor, setIntensidadDolor,
    minimental, setMinimental,
    escalaDolor, setEscalaDolor,
    kinesiofobia, setKinesiofobia,
    catastrofismo, setCatastrofismo,
    gradacionDolorCronico, setGradacionDolorCronico,
    sf12, setSf12,
    openGood, setOpenGood,
    isEdit,
    handleScaleChange,
    guardarDatos,
  };
};
